const isAddressObject = (value) =>
  value && typeof value === "object" && !Array.isArray(value);

export const normaliseAddressChange = (value) => {
  if (!isAddressObject(value)) return null;

  const address = isAddressObject(value.address)
    ? value.address
    : value.del_name || value.del_add1 || value.del_postcode
    ? value
    : null;

  if (!address) return null;

  const parsedState = Number.parseInt(value.state, 10);
  const state = Number.isFinite(parsedState) ? parsedState : 1;

  if (state <= 0) return null;

  return {
    state,
    address,
    updatedDatetime:
      value.updated_datetime || value.updatedDatetime || null,
  };
};

export const resolveDeliveryAddress = (originalAddress, addressChange) => {
  if (!addressChange?.address) return originalAddress || null;

  return {
    ...(originalAddress || {}),
    ...addressChange.address,
  };
};
